import type { SongData } from "../types";

interface ArtistOption {
  Id: number;
  Artist: string;
  ProfilePicture: string;
  Genre: string;
}

interface UserInfo {
  id: number;
  displayName: string;
  email: string;
  profilePicture: string;
}

interface Notification {
  Id: number;
  notification_message: string;
  notification_link: string;
  postedDate: string;
  notificationType: string;
}

export async function getArtists(): Promise<ArtistOption[]> {
  const res = await fetch("/api/getArtists");
  return res.json();
}

export async function getArtistSongCount(artistId: number): Promise<number> {
  const res = await fetch(`/api/getArtistSongCount?artistId=${artistId}`);
  const data = await res.json();
  return data.songCount;
}

export async function getSongsByArtist(artistId: number, limit: number): Promise<SongData[]> {
  const res = await fetch(`/api/getSongsByArtist?artistId=${artistId}&limit=${limit}`);
  return res.json();
}

export async function getRandomSongs(limit: number): Promise<SongData[]> {
  const res = await fetch(`/api/getRandomSongs?limit=${limit}`);
  return res.json();
}

export async function getUserInfo(): Promise<{ user: UserInfo; savedBrackets: unknown[] } | null> {
  const res = await fetch("/api/getUserInfo", { credentials: "include" });
  if (!res.ok) return null;
  return res.json();
}

export async function getNotifications(): Promise<Notification[]> {
  const res = await fetch("/api/getNotifications", { credentials: "include" });
  if (!res.ok) return [];
  return res.json();
}

export async function getGenres(): Promise<string[]> {
  const res = await fetch("/api/getGenres");
  return res.json();
}

export interface PublicBracket {
  Id: number;
  game_mode: string;
  game_type: string;
  bracket_size: number;
  artist_selected: string | null;
  winner_song_name: string;
  winner_artist: string;
  likes_count: number;
  created_date: string;
  display_name: string;
  profile_picture: string;
  user_liked: boolean;
}

interface PublicBracketsResponse {
  brackets: PublicBracket[];
  total: number;
  page: number;
  totalPages: number;
}

export async function getPublicBrackets(
  page = 1,
  sort: "recent" | "popular" = "recent",
): Promise<PublicBracketsResponse> {
  const res = await fetch(`/api/getPublicBrackets?page=${page}&sort=${sort}`, {
    credentials: "include",
  });
  return res.json();
}
